//////////////////////////////////////////////////
//
//
//  変数定義
//
//
//////////////////////////////////////////////////
//  ①メイン：「active／hidden」クラスを付与する要素
const header = document.querySelector(".c-header");

//  ②ボタン：スマホでメニューを開閉するボタン要素
const menuButton = document.querySelector(".c-header__menu-button");

//  ③ナビ：スマホで見え隠れするメニュー要素
const navigation = document.querySelector(".c-header__nav");

//  ④メディアクエリ：スマホ版／PC版を判定
const mediaQuery = window.matchMedia("(min-width:1180px)");

//////////////////////////////////////////////////
//
//
//  メニューボタンクリック毎の処理
//
//
//////////////////////////////////////////////////
function menuStatus(boolean = false) {
    if (boolean) {
        navigation?.setAttribute("aria-hidden", false);
        menuButton?.setAttribute("aria-expanded", true);
        menuButton?.setAttribute("aria-label", "メニューを閉じる");
        document.body.style.overflow = "hidden";
    } else {
        navigation?.setAttribute("aria-hidden", true);
        menuButton?.setAttribute("aria-expanded", false);
        menuButton?.setAttribute("aria-label", "メニューを開く");
        document.body.style.overflow = "revert";
    }
}
//////////////////////////////////////////////////
//
//
//  ブラウザ幅可変時（SP⇔PC）の処理
//
//
//////////////////////////////////////////////////
function setAccessibilityStatus(e) {
    //  スマホ版のときだけ必要な属性を付与する
    if (!mediaQuery.matches) {
        menuButton?.setAttribute("aria-controls", "nav");
        menuButton?.setAttribute("aria-expanded", "false");
        menuButton?.setAttribute("aria-label", "メニューを開く");
        navigation?.setAttribute("aria-hidden", "true");
    } else {
        menuButton?.removeAttribute("aria-expanded");
        menuButton?.removeAttribute("aria-controls");
        menuButton?.removeAttribute("aria-label");
        navigation?.removeAttribute("aria-hidden");
    }
}
//////////////////////////////////////////////////
//
//
//  関数実行
//
//
//////////////////////////////////////////////////
//=========================
//
//  ロード時の処理
//
//=========================
setAccessibilityStatus(mediaQuery);

//=========================
//
//  ブラウザ可変時の処理
//
//=========================
mediaQuery.addEventListener("change", setAccessibilityStatus);

//=========================
//
//  ボタンクリック時の処理
//
//=========================
menuButton?.addEventListener("click", () => {
    //  「active」クラスをトグルセット（あればつけない／なければつける）
    //  戻り値として返されるboolean値を定数に格納（つけたらtrue／外したらfalse）
    const isActive = header?.classList.toggle("active");

    //  外れた（false）場合は「hidden」クラスをセット
    //  ※ページロード時以外は必ず「active／hidden」のどちらかが付く
    header?.classList.toggle("hidden", !isActive);
    //
    menuStatus(isActive);
});
